module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.c88e8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_hero_768.png
// module id = FcXp
// module chunks = 0